import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import sign from '../img/acrew2.png'
import {Button} from "react-bootstrap";
import Header from '../components/Header';

const MaterialList = () => {
    const [materials, setMaterials] = useState([]);

    useEffect(() => {
        fetch('https://ems.lexikonn.eu/api/get_materials.php')
            .then(res => res.json())
            .then(data => setMaterials(data));
    }, []);

    return (
        <div className="container py-5">
            <Header/>
            <div className="mb-3">
                <Link to={"/"}><Button size="sm" variant="danger">Zpět</Button></Link>
            </div>
            <h2 className="mb-4">Materiály</h2>
            <ul className="list-group list-group-flush">
                {materials.map((item) => (
                    <Link
                        key={item.id}
                        to={`/materialy/${item.id}`}
                        className="list-group-item bg-transparent text-light p-4 list-group-item-action"
                    >
                        Dokument č.{item.id} - <b>{item.title}</b>
                    </Link>
                ))}
            </ul>
            <div className="mt-5 lead text-end">
                <div className="mb-3">Dokumenty vypracoval Alex Crew <b className="text-secondary">(Lexikonn)</b></div>
                <img style={{opacity: 0.5, userSelect: "none", pointerEvents: "none", maxHeight: "100px"}} src={sign}/>
            </div>
        </div>
    );
};

export default MaterialList;
